module.exports = __webpack_public_path__ + "static/media/Anuncio.5cd62a3e.svg";